import { forwardRef, type Ref, type SVGProps } from "react";
const IconLightningFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M19 2.61a.532.532 0 0 0-.96-.38L7.1 18.14c-.11.17-.13.38-.04.56s.27.29.47.29h9.12c.27 0 .5-.21.53-.48L19 2.6z"
    />
    <path
      fill="currentColor"
      d="M13 29.39a.532.532 0 0 0 .96.38L24.9 13.86c.11-.17.13-.38.04-.56a.52.52 0 0 0-.47-.29h-9.12c-.27 0-.5.21-.53.48L13 29.4z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLightningFilledSVG);
ForwardRef.displayName = "IconLightningFilled";
export { ForwardRef as IconLightningFilled };
